export default {
  推荐66人: `推荐66人<br class="mobile" /> 邀您直通巴萨`,
  成为EBC推荐官: "成为EBC推荐官，享受VIP荣耀之旅",
  立即参与: "立即参与",
  活动规则与要求: "活动规则与要求",
  每一次推荐: "每一次推荐，通往巴塞罗那足球俱乐部的黄金助攻",
  参与规则: "参与规则：",
  成为EBC推荐官并邀请66人: "成为EBC推荐官并邀请66人；",
  所有被邀请人均入金大于等于$500: `所有被邀请人均入金大于等于$500，<br class="mobile" />且完成交易。`,
  参与方法: "参与方法",
  立即推荐: "立即推荐，以好友的助力，向传奇致敬",
  登录EBC用户中心: "登录EBC用户中心",
  "进入“大赛推荐官”活动页面": "进入“大赛推荐官”活动页面",
  生成您的邀请链接或二维码: "生成您的邀请链接或二维码",
  巴萨荣耀之旅: "巴萨荣耀之旅",
  每笔订单都是攻守博弈的艺术: `每笔订单都是攻守博弈的艺术，<br class="mobile" />每个决策都将缔造资本市场的史诗级射门。`,
  活动时间: "活动时间",
  "2025年2月22日": "2025年2月22日 01:00:00(MT4/MT5时间)-2025年8月(MT4/MT5时间)",
  活动规则: "活动规则",
  ruleList: [
    "该活动与正常推荐奖励和其他活动不存在冲突。",
    "被推荐人需完成入金并交易，第三方转账无效。",
    "推荐奖励适用于合规交易者，EBC有权对违规行为取消奖励资格。",
    "通过邀请活动注册的账户不允许转移代理。",
    "获奖以账号有效激活为准，VIP观赛席位含机票和住宿。",
    "本活动最终解释权归EBC金融集团所有。",
  ],
};
